import type {ReportMode} from '~/models/environmentReport'

export const QUESTION_TEMPLATE_TYPE_ENVIRONMENT_CONSIDERATION = 1
export const QUESTION_TEMPLATE_TYPE_ENVIRONMENT_REPORT = 2

export const QUESTION_OPTION_CONFIG_TEXT = 1
export const QUESTION_OPTION_CONFIG_YESNO = 2
export const QUESTION_OPTION_CONFIG_NUMBER = 3

export const QUESTION_ENABLE_COMMENT_NEVER = 1
export const QUESTION_ENABLE_COMMENT_ALWAYS_OPTIONAL = 2
export const QUESTION_ENABLE_COMMENT_ALWAYS_REQUIRED_IF_YES = 3
export const QUESTION_ENABLE_COMMENT_ALWAYS_REQUIRED_IF_NO = 4
export const QUESTION_ENABLE_COMMENT_ALWAYS_REQUIRED = 5

export const QUESTION_CATEGORY_PREPARATION = 1
export const QUESTION_CATEGORY_ENVIRONMENT_CONSIDERATION = 2
export const QUESTION_CATEGORY_OPERATION_PLANNING = 3

export const QUESTION_CATEGORIES = [
    QUESTION_CATEGORY_PREPARATION,
    QUESTION_CATEGORY_ENVIRONMENT_CONSIDERATION,
    QUESTION_CATEGORY_OPERATION_PLANNING,
]

export interface PhaseConfig {
    templateType: number
    contractKey: 'EnvironmentConsideration' | 'EnvironmentReportQuestionSet'
    counterpart: ReportMode
    counterpartLabel: string
    tabLabel: string
}

export const PHASE_CONFIG: Record<ReportMode, PhaseConfig> = {
    Consideration: {
        templateType: QUESTION_TEMPLATE_TYPE_ENVIRONMENT_CONSIDERATION,
        contractKey: 'EnvironmentConsideration',
        counterpart: 'AccountedFor',
        counterpartLabel: 'ACCOUNTED_FOR_AFTER_HOGGER',
        tabLabel: 'PHASE_BEFORE_HARVEST',
    },
    AccountedFor: {
        templateType: QUESTION_TEMPLATE_TYPE_ENVIRONMENT_REPORT,
        contractKey: 'EnvironmentReportQuestionSet',
        counterpart: 'Consideration',
        counterpartLabel: 'ACCOUNTED_FOR_BEFORE_HOGGER',
        tabLabel: 'PHASE_AFTER_HARVEST',
    },
}
